import * as React from 'react';
import {EditBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import { PopupModel} from "../../model";
import {PopupService} from "../../services";
import { CreateForm } from './form/CreateForm';

export class PopupEdit extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      form: {} as PopupModel
    }
  }

  init = async () => {
    const form: PopupModel = await PopupService.get(this.state.id)
    this.setState({
      form
    })
  }

  componentDidMount() {
    this.init();
  }

  render() {
    return (
        <CreateLayout breadcrumb={EditBreadcrumb} title={'Edit'}>
          <CreateForm {...this.state}/>
        </CreateLayout>
    )
  }
}